import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function add({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="black"
      className={className}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21 12a9 9 0 11-9-9 9 9 0 019 9zm-9 1c0-2 3-1 3-4S9 6 9 9"
      ></path>
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.6"
        d="M12.05 17L11.95 17"
      ></path>
    </svg>
  );
}

export default add;
